// extracted by mini-css-extract-plugin
export default {"label":"ElementName_label__jDPXP"};